import React, { createContext, useContext, useState, useEffect } from 'react';
import { systemSettingsService } from '../services/api';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState({
    code: 'INR',
    symbol: '₹',
    position: 'prefix'
  });
  const [loading, setLoading] = useState(true);

  // Format price with currency
  const formatPrice = (price) => {
    const numPrice = parseFloat(price);
    if (isNaN(numPrice)) return `${currency.symbol}0.00`;
    
    const formattedPrice = numPrice.toFixed(2);
    
    if (currency.position === 'prefix') {
      return `${currency.symbol}${formattedPrice}`;
    } else {
      return `${formattedPrice}${currency.symbol}`;
    }
  };

  // Load currency settings from API
  const loadCurrency = async () => {
    try {
      console.log('[CurrencyContext] Loading currency settings...');
      const response = await systemSettingsService.getPublicSettings();
      
      if (response.data && response.data.success && response.data.data.currency) {
        const currencyData = response.data.data.currency;
        console.log('[CurrencyContext] Currency loaded:', currencyData);
        setCurrency(currencyData);
      } else {
        // Try the direct currency endpoint as fallback
        const currencyResponse = await systemSettingsService.getCurrency();
        if (currencyResponse.data && currencyResponse.data.success) {
          console.log('[CurrencyContext] Currency loaded from fallback:', currencyResponse.data.data);
          setCurrency(currencyResponse.data.data);
        }
      }
    } catch (error) {
      console.warn('[CurrencyContext] Failed to load currency, using default INR:', error);
      // Keep default INR currency
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCurrency();
  }, []);

  const value = {
    currency,
    formatPrice,
    loading,
    refreshCurrency: loadCurrency
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyContext; 